import styled from 'styled-components';

export const ContainerFoundEmail = styled.div`
  .email-masked {
    font-size: 18px;
    font-weight: bold;
    line-height: 28px;
    color: ${({ tema }) => tema.primaryColor};
    margin: 24px auto;
  }

  .container-buttons {
    margin-top: 40px;
    display: flex;
    gap: 16px;
  }

  .backButton {
    display: flex;
    justify-content: center;
    border-top: 1px solid #b1b3b3;
    margin-top: 24px;
    padding-top: 24px;

    span {
      color: ${({ tema }) => tema.primaryColor};
      font-size: 16px;
      font-weight: bold;
      display: flex;
      align-items: center;
      gap: 8px;
      cursor: pointer;
    }
  }

  @media (max-width: 768px) {
    .container-buttons {
      flex-direction: column-reverse;
    }
  }
`;
